import { useEffect, useRef, useState } from "react";
import Icon from "../Icon";
import TooltipProductInfo from "../TooltipProductInfo";
import CircleCheckbox from "../CircleCheckbox";
import ProductPriceAlert from "../ProductPriceAlert";
import PlanFeatureUpgradeModal from "../PlanFeatureUpgradeModal";
import { convertIntToMoney, formatNumberWithDot } from "../../helpers/conversions";
import { canSeeProductCost, canSeeProductSupplier, canSeeStock, hasPermission, hasPlanFeature } from "../../services/auth";

export default function CardProductInfo({ product, checkBoxAction, isChecked, totalStock, subProducts, title, image, sku, price, index, setSimilarProduct}) {
  const [upgradeFeature, setUpgradeFeature] = useState(null);
  const [showNameTooltip, setShowNameTooltip] = useState(false);
  const tooltipTimerRef = useRef(null);
  const productTooltipTitle = title || 'Produto';
  const productTooltipSku = sku ? sku : null;

  const handleCardClick = () => {
    checkBoxAction();
  };

  const handleDetailsClick = e => {
    e.stopPropagation();
    window.open(`/product/edit/${product.id}`);
  };

  const handleSimilarClick = e => {
    e.stopPropagation();
    if (hasPlanFeature('similar_search')) {
      setSimilarProduct(product);
    } else {
      setUpgradeFeature('similar_search');
    }
  };

  const handlePriceUpgradeClick = e => {
    e.stopPropagation();
    setUpgradeFeature('calculation');
  };

  const handleNameMouseEnter = () => {
    clearTimeout(tooltipTimerRef.current);
    tooltipTimerRef.current = setTimeout(() => {
      setShowNameTooltip(true);
    }, 80);
  };

  const handleNameMouseLeave = () => {
    clearTimeout(tooltipTimerRef.current);
    setShowNameTooltip(false);
  };

  useEffect(() => {
    return () => {
      clearTimeout(tooltipTimerRef.current);
    };
  }, []);

  return (
    <>
    <PlanFeatureUpgradeModal
      feature={upgradeFeature}
      show={upgradeFeature !== null}
      close={() => setUpgradeFeature(null)}
    />
    <div
      className="with-pagination with-filter-inline product-info-card"
      onClick={handleCardClick}
    >
      <div className="product-card-info-head">
        <CircleCheckbox isChecked={isChecked} onClick={checkBoxAction} />
        <div className="product-card-actions">
          {hasPermission('view_product') &&
            <button type="button" aria-label="Abrir detalhes do produto" onClick={handleDetailsClick}>
              <Icon name="external-link" size={13} />
              <span className="action-label">Detalhes</span>
            </button>
          }
          <button type="button" aria-label="Buscar produtos parecidos" onClick={handleSimilarClick}>
            <Icon name="search" size={13} />
            <span className="action-label">Parecidos</span>
          </button>
        </div>
        <div className="product-card-info-image-wrap">
          {product.image?.image_url?.thumbnail ? (
            <img
              src={product.image?.image_url?.thumbnail}
              alt={`${productTooltipTitle}${productTooltipSku ? ` - ${productTooltipSku}` : ''}`}
              aria-label={`${productTooltipTitle}${productTooltipSku ? ` - ${productTooltipSku}` : ''}`}
              className="product-info-card-image img-fluid"
            />
          ) : (
            <img
              src={ require(`../../assets/images/svgs/default-transparent.svg`).default }
              alt={`${productTooltipTitle}${productTooltipSku ? ` - ${productTooltipSku}` : ''}`}
              aria-label={`${productTooltipTitle}${productTooltipSku ? ` - ${productTooltipSku}` : ''}`}
              className="product-info-card-image img-fluid"
            />
          )}
        </div>
      </div>
      <div className="product-card-info-footer">
        {showNameTooltip && (
          <div className="product-image-tooltip">
            <span className="product-image-tooltip-title">{productTooltipTitle}</span>
            {productTooltipSku && (
              <span className="product-image-tooltip-sku">{productTooltipSku}</span>
            )}
          </div>
        )}
        <p
          className="product-card-name"
          onMouseEnter={handleNameMouseEnter}
          onMouseLeave={handleNameMouseLeave}
        >
          {title}
        </p>
        <p
          className="product-card-sku"
          onMouseEnter={handleNameMouseEnter}
          onMouseLeave={handleNameMouseLeave}
        >
          {sku}
        </p>
        {canSeeProductSupplier() && (
          <p className="product-card-supplier">{product?.company_trade_name ?? '-'}</p>
        )}
        <div className="info-details">
          {canSeeProductCost() && !hasPlanFeature('calculation') ? (
            <button className="btn-upgrade-inline" onClick={handlePriceUpgradeClick}>
              🔒 Preço e estoque
            </button>
          ) : (
            <>
              {canSeeProductCost() && (
                <span className="product-card-price-label">A partir de</span>
              )}
              {canSeeProductCost() && (
                <p className="product-card-price">
                  R$ {convertIntToMoney(price)} <ProductPriceAlert product={product} />
                </p>
              )}
              {canSeeStock() && (
                <p className="product-card-stock">
                  {formatNumberWithDot(totalStock)} em estoque <TooltipProductInfo dataInfo={subProducts} productIndex={index} />
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
    </>
  );
}
